import React from 'react';
import './Navigation.css'
// import logo from '../../../img/MDRafiulAlamLogo.png'

const Navigation = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light">
      <div className="container-fluid container">
        <a className="navbar-brand" href="#"><img alt="" /></a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav ms-auto">
          <li className="nav-item">
              <a className="nav-link px-4" href="#about">About</a>
            </li>
            <li className="nav-item px-4">
              <a className="nav-link" href="#about">Resume</a>
            </li>
            <li className="nav-item px-4">
              <a className="nav-link" href="#skills">Skills</a>
            </li>
            <li className="nav-item px-4">
              <a className="nav-link" href="#portfolio">Portfolio</a>
            </li>
            <li className="nav-item px-4">
              <a className="nav-link" href="#contact">Contact</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;